import { render } from "./ViewRiskInfoModal.vue?vue&type=template&id=5d775e22&scoped=true"
import script from "./ViewRiskInfoModal.js?vue&type=script&lang=js"
export * from "./ViewRiskInfoModal.js?vue&type=script&lang=js"

import "./ViewRiskInfoModal.vue?vue&type=style&index=0&id=5d775e22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d775e22"]])

export default __exports__